import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  page: 1,
  formData: {
    projectName: "",
    area: "",
    taskName: [],
    client: "",
    location: "",
    budget: "",
    latitude: "",
    longitude: "",
    worker: [],
    completionDate: "",
    startDate: "",
    description: "",
    projectId: "",
  },
};

const addProjectSlice = createSlice({
  name: "addProject",
  initialState,
  reducers: {

    setPage: (state, action) => {
      state.page = action.payload;
    },
    setFormData: (state, action) => {
      state.formData = { ...state.formData, ...action.payload };
    },
    resetForm: (state) => {
      state.formData = initialState.formData;
    },
  },
});

export const { setPage, setFormData, resetForm } = addProjectSlice.actions;
export default addProjectSlice.reducer;
